import { InputNumber } from 'primereact/inputnumber';
import '../assets/estimated-duration-field.css';

export function EstimatedDurationField({ value, onChange, error, compact = false }: {
    value?: number | null; onChange: (value: number | null) => void; error?: string;
    compact?: boolean;
}) {
    const help = 'Optional. Your estimate for completing this lesson.';
    return <div className={`field${compact ? ' estimated-duration-field-compact' : ''}`}>
        <label htmlFor="estimated-minutes">Estimated duration (minutes)</label>
        <InputNumber inputId="estimated-minutes" value={value ?? null} onValueChange={event => onChange(event.value ?? null)}
            min={1} max={1440} maxFractionDigits={0} useGrouping={false}
            className={error ? 'w-full p-invalid' : 'w-full'} aria-describedby="estimated-minutes-help" />
        <small id="estimated-minutes-help" className={error ? 'p-error' : 'text-color-secondary'}>
            {error ?? help}
        </small>
    </div>;
}
